export interface IdGenerator {
    id: string;
}
export class BrazeMessageIdGenerator implements IdGenerator {
    private identifier: number;

    public constructor() {
        this.identifier = 0;
    }

    // generates message id for braze messages that are  process immediately and stored for further processing
    public get id() {
        this.identifier += 1;
        return String(this.identifier);
    }
}
